import { useEffect, useState } from "react";
import api from "../../lib/api";
import BusinessCard from "../../components/BusinessCard";

export default function Favorites() {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/favorites")
      .then(({ data }) => setFavorites(data))
      .catch(() => setFavorites([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-muted-foreground">Loading…</p>;

  return (
    <div>
      <h1 className="mb-4 font-montserrat text-2xl font-bold text-slate-900">Favorites</h1>
      {favorites.length === 0 ? (
        <p className="text-muted-foreground">Save businesses you love to find them here.</p>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {favorites.map((b) => (
            <BusinessCard key={b.id} business={b} />
          ))}
        </div>
      )}
    </div>
  );
}
